import { Avatar, ButtonSecondary, Frame, IconWallet, Separator, SpacerVertical, Typography } from '@klarna/bubble-ui';
import { useResponsiveContext } from '@klarna/mp-ui';
import { AddApiKeySuccessModal } from '@merchant-portal/credentials';
import { hooks as i18nHooks } from 'mage-i18n';
import React from 'react';
import styled from 'styled-components';
import TrackableLink from '../../../../../../components/TrackableLink';
import { useApiKey } from '../../hooks/useApiKey';
import { useMid } from '../../hooks/useMid';
import { usePlugin } from '../../hooks/usePlugin';
import { getButtonContainer, getInstructionContainer, getInstructionTextContainer, IconContainer, RowContainer } from '../styled';
import ApiKeyBanner from './ApiKeyBanner';
const TRANSLATION_PREFIX = 'home-fe.boosters-plugin.instructions.api-key';
const MainContainer = styled.div.withConfig({ displayName: "MainContainer", componentId: "sc-1avuohv" }) `
  display: block;
`;
export default function ApiKeyInstructions() {
    const t = i18nHooks.useTranslator();
    const { pluginDocUrl, pluginId } = usePlugin();
    const { isMobile } = useResponsiveContext();
    const { areActionsEnabled, isSuccessModalOpen, createApiKeyData, createApiKey, onSuccessModalClose } = useApiKey();
    const { selectedMid } = useMid();
    const ButtonContainer = getButtonContainer(isMobile);
    const InstructionContainer = getInstructionContainer(isMobile);
    const InstructionTextContainer = getInstructionTextContainer(isMobile);
    return (React.createElement(Frame, { paddingToken: 'space.0' },
        React.createElement(MainContainer, null,
            React.createElement(InstructionContainer, null,
                React.createElement(RowContainer, null,
                    React.createElement(IconContainer, null,
                        React.createElement(Avatar, { icon: IconWallet, medium: true })),
                    React.createElement(InstructionTextContainer, null,
                        React.createElement(Typography, { textToken: 'text-style/text/paragraphs/body/bold' }, t(`${TRANSLATION_PREFIX}.title`)),
                        React.createElement(SpacerVertical, { spaceToken: 'space.100' }),
                        React.createElement(Typography, { textToken: 'text-style/text/paragraphs/body/regular' },
                            t(`${TRANSLATION_PREFIX}.content`),
                            ' ',
                            React.createElement(TrackableLink, { href: pluginDocUrl, openInNewWindow: true, rel: "noopener noreferrer", category: `boost-home/plugin-guide/${pluginId}/klarna-docs-link`, label: selectedMid !== null && selectedMid !== void 0 ? selectedMid : '' }, t(`${TRANSLATION_PREFIX}.link-label`))))),
                React.createElement(ButtonContainer, null,
                    React.createElement(ButtonSecondary, { size: 'medium', onClick: createApiKey, disabled: !areActionsEnabled }, t(`${TRANSLATION_PREFIX}.generate`)))),
            React.createElement(SpacerVertical, { spaceToken: 'space.400' }),
            React.createElement(RowContainer, null,
                React.createElement(ApiKeyBanner, null))),
        isSuccessModalOpen &&
            React.createElement(AddApiKeySuccessModal, { data: createApiKeyData, onClose: onSuccessModalClose }),
        React.createElement(SpacerVertical, { spaceToken: 'space.400' }),
        React.createElement(Separator, { colorToken: "colors/backgrounds/subtle-floating" })));
}
